<template>
    <!-- FullscreenSpeedDial.vue -->
    <v-speed-dial v-show="value" bottom fixed right>
        <template v-slot:activator>
            <v-tooltip left>
                <template v-slot:activator="{on}">
                    <v-btn
                        data-test="speedDialButton"
                        v-on="on"
                        :color="color"
                        dark
                        fab
                        @click="handleFullscreen"
                    >
                        <v-icon>{{ icon }}</v-icon>
                    </v-btn>
                </template>
                {{ text }}
            </v-tooltip>
        </template>
    </v-speed-dial>
</template>

<script>
    export default {
        name: 'FullscreenSpeedDial',
        data: () => ({
            fullscreen: false
        }),
        props: {
            /**
             * The DOM id of the element to request fullscreen on
             */
            elementId: {
                type: String,
                default: 'app'
            },
            /**
             * Toggle visibility
             */
            value: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            color () {
                return this.fullscreen ? 'accent' : 'info'
            },
            icon () {
                return this.fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'
            },
            text () {
                return this.fullscreen ? 'Exit Fullscreen' : 'Fullscreen'
            }
        },
        methods: {
            handleFullscreen () {
                // Disable fullscreen
                if (document.fullscreenElement) {
                    document.exitFullscreen()
                    return
                }

                // Enable fullscreen
                document.getElementById(this.elementId).requestFullscreen()
            }
        },
        created () {
            const vm = this
            // Toggle fullscreen boolean on change
            document.onfullscreenchange = () => {
                vm.fullscreen = !vm.fullscreen
            }
        }
    }
</script>
